export default function ProgressBar({ current, total, labels }) {
  return (
    <div className="progress-bar-wrapper">
      <div className="progress-track">
        <div
          className="progress-fill"
          style={{ width: `${(current / (total - 1)) * 100}%` }}
        />
        {labels.map((label, i) => (
          <div
            key={label}
            className={`progress-dot ${i < current ? "done" : i === current ? "active" : ""}`}
            style={{ left: `${(i / (total - 1)) * 100}%` }}
            title={label}
          />
        ))}
      </div>
    </div>
  );
}
